import { CommonActions, StackActions } from '@react-navigation/native';

import { DRIVER_ROUTE } from '../../scenes/driver/driverRoutes';

/**
 * Tab-style navigation from outside the main stack (bottom bar, side menu):
 * back to `routeName` if it is in the stack, otherwise start over from Home
 * (keeping the mounted Home screen) with `routeName` on top.
 * - navigation: the drawer-level navigation object
 * - stack: the main stack state ({ key, routes })
 */
const goToShellRoute = (navigation, stack, routeName) => {
	const routes = stack?.routes || [];
	if (!routes.length) {
		navigation.navigate('MainStack', { screen: routeName });
		return;
	}

	const existingIndex = routes.map(route => route.name).lastIndexOf(routeName);
	if (existingIndex >= 0 && existingIndex === routes.length - 1) {
		return;
	}
	const homeRoute = routes[0]?.name === DRIVER_ROUTE.HOME ? routes[0] : { name: DRIVER_ROUTE.HOME };
	let nextRoutes = routeName === DRIVER_ROUTE.HOME ? [homeRoute] : [homeRoute, { name: routeName }];
	if (existingIndex >= 0) {
		nextRoutes = routes.slice(0, existingIndex + 1);
	}

	// Right after a switch the drawer can hold the stack's state without its key; an
	// untargeted navigate would then push the page on top (Back, slide-in), so replace
	// the stack's state through the drawer instead.
	if (!stack.key) {
		navigation.navigate('MainStack', { state: { index: nextRoutes.length - 1, routes: nextRoutes } });
		return;
	}
	if (existingIndex >= 0) {
		// Merge keeps the screen's params (popTo replaces them otherwise).
		navigation.dispatch({ ...StackActions.popTo(routeName, undefined, { merge: true }), target: stack.key });
		return;
	}

	navigation.dispatch({
		...CommonActions.reset({ index: nextRoutes.length - 1, routes: nextRoutes }),
		target: stack.key,
	});
};

// The main stack state inside a drawer navigation state.
export const getMainStackState = drawerState => drawerState?.routes?.find(route => route.name === 'MainStack')?.state;

export default goToShellRoute;
